import { render, staticRenderFns } from "./IconsSocial.vue?vue&type=template&id=4a58e76c&scoped=true&"
import script from "./IconsSocial.vue?vue&type=script&lang=js&"
export * from "./IconsSocial.vue?vue&type=script&lang=js&"
import style0 from "./IconsSocial.vue?vue&type=style&index=0&id=4a58e76c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a58e76c",
  null
  
)

export default component.exports